import { z } from "zod";
import { isValidCnpj } from "../../../../../utils/format-utils";
import { pipeSeparatedEmails } from "../../../../../utils/zod-schemas";

export const companyRegistrationSchema = z.object({
  cnpj: z
    .string()
    .min(1, "CNPJ é obrigatório")
    .refine((val) => isValidCnpj(val), {
      message: "CNPJ inválido",
    }),
  razaoSocial: z.string().min(1, "Razão Social é obrigatória"),
  cep: z
    .string()
    .min(1, "CEP é obrigatório")
    .refine((val) => val.replace(/\D/g, "").length === 8, {
      message: "CEP deve ter 8 dígitos",
    }),
  endereco: z.string().min(1, "Endereço é obrigatório"),
  apelido: z.string().min(1, "Apelido (OPS) é obrigatório"),
  emailContato: pipeSeparatedEmails,
  nfsAtivo: z.boolean(),
  nfsSrAtivo: z.boolean(),
  franquiaUuid: z
    .string()
    .uuid("UUID inválido")
    .optional()
    .or(z.literal("")),
  redutor: z
    .number()
    .min(0, "Redutor deve ser no mínimo 0")
    .max(1, "Redutor deve ser no máximo 1")
    .optional(),
});

export const editCredentialsSchema = z.object({
  apelido: z.string().min(1, "Apelido (OPS) é obrigatório"),
  emailContato: pipeSeparatedEmails,
  nfsAtivo: z.boolean(),
  nfsSrAtivo: z.boolean(),
  franquiaUuid: z
    .string()
    .uuid("UUID inválido")
    .optional()
    .or(z.literal("")),
  redutor: z
    .number()
    .min(0, "Redutor deve ser no mínimo 0")
    .max(1, "Redutor deve ser no máximo 1")
    .optional(),
});

export type CompanyRegistrationFormData = z.infer<
  typeof companyRegistrationSchema
>;
export type EditCredentialsFormData = z.infer<typeof editCredentialsSchema>;
